// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__r-hB7","skills":"Skills_skills__RHtIi"};